module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-murale-edge-02.b7b1a510.jpg";